/**
 * UI del módulo QMS «Reclamos» desactivada por producto.
 * Cambiar a `true` para volver a registrar rutas y entrada de menú bajo /registros/reclamos.
 */
export const QMS_RECLAMOS_UI_ENABLED = false;
